<template>
  <div v-if="Lib.checkPower('beauty-2-xzyyyyxm',2)" class="receptionOverflow">
    <div class="flex">
      <el-form ref="ruleForm" style="margin: 30px 0 0 0;" :model="form" :rules="rules" label-width="130px">
        <el-form-item label="手机号码：" prop="phone" required>
          <el-input v-model.trim="form.phone" class="width_200" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{})[\d+\.]/g, '')" :disabled="form.bookAmount > 0 || form.deductType == 1" placeholder="请输入手机号码" :maxlength="11" @keyup.enter.native="Lib.keyboardBlur"></el-input>
          <i class="iconfont phone_book new_phone_style" @click="onCheckPhoneBook">&#xe646;</i>
        </el-form-item>
        <div class="starPhoneClass">{{ starPhoneVal }}</div>
        <el-form-item label="顾客姓名：" prop="name">
          <el-input v-model.trim="form.name" class="width_200" placeholder="请输入顾客姓名" :maxlength="15" :disabled="nameInput == 2 || form.bookAmount > 0 || form.deductType == 1" @keyup.enter.native="Lib.keyboardBlur"></el-input>
        </el-form-item>
        <el-form-item label="项目选择：" prop="technician" required>
          <el-button type="primary" style="float: left;" @click="chooseService">选择项目</el-button>
          <div v-if="form.comfirmRadioName" class="bespeakServiceChoose">项目名称：{{ form.comfirmRadioName }}</div>
        </el-form-item>
        <el-form-item label="服务占用时长：" prop="date" required>
          <el-select v-model="timeVal" style="width: 220px;margin-right: 20px;" @change="durationTime">
            <el-option label="15分钟" :value="15"></el-option>
            <el-option label="30分钟" :value="30"></el-option>
            <el-option label="45分钟" :value="45"></el-option>
            <el-option label="60分钟" :value="60"></el-option>
            <el-option label="75分钟" :value="75"></el-option>
            <el-option label="90分钟" :value="90"></el-option>
            <el-option label="105分钟" :value="105"></el-option>
            <el-option label="120分钟" :value="120"></el-option>
            <el-option label="135分钟" :value="135"></el-option>
            <el-option label="150分钟" :value="150"></el-option>
            <el-option label="165分钟" :value="165"></el-option>
            <el-option label="180分钟" :value="180"></el-option>
            <el-option label="195分钟" :value="195"></el-option>
            <el-option label="210分钟" :value="210"></el-option>
            <el-option label="225分钟" :value="225"></el-option>
            <el-option label="240分钟" :value="240"></el-option>
            <el-option label="自定义" value="自定义"></el-option>
          </el-select>
          <el-tooltip effect="light" content="服务项目的实际占用时长" placement="top">
            <i class="el-icon-warning" style="color:#D2D2D2" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="预约时间：" prop="date" required>
          <el-date-picker v-model="form.date" class="width_200" align="right" type="date" placeholder="选择日期" :clearable="false" :picker-options="pickerOptions" value-format="yyyy-MM-dd" :editable="false" @change="getDate">
          </el-date-picker>
          <el-popover v-show="form.comfirmRadioName" placement="bottom" width="880" trigger="click">
            <p v-if="form.timeList.length == 0" style="padding: 20px;">暂无预约时间~</p>
            <div v-else class="chooseContent">
              <ul>
                <li v-for="(v,n) in form.timeList" :key="n" :class="String(form.chooseTimeIndex).length>0 &&n == form.chooseTimeIndex?'choose':''" @click="form.comfirmRadioName ?chooseTime(n,v):''">
                  <span>{{ v.startDate }}</span>
                  <samp v-show=" String(form.chooseTimeIndex).length>0 &&n == form.chooseTimeIndex&&v.isNoBook == 0 && v.isOrder == 0">至{{ v.endDate }}</samp>
                  <samp v-show="v.bookNumber < 5 &&v.isNoBook == 0 && v.isOrder == 0 &&(String(form.chooseTimeIndex).length>0? n != form.chooseTimeIndex:' ')">(剩{{ v.bookNumber }})</samp>
                  <samp v-show="v.isNoBook == 1">(不可约)</samp>
                  <label v-show="v.isOrder == 1">(约满)</label>
                </li>
              </ul>
              <div class="ctFoot">
                <span>预约时间：</span>
                <span v-if="form.timeStart">{{ form.timeStart }} - {{ form.timeEnd }}</span>
                <span v-else-if="String(form.chooseTimeIndex).length>0 &&form.timeList.length>0 ">
                  {{ form.timeList[0].bookNumber > 0 && form.timeList[0].isNoBook == 0 && form.timeList[0].isOrder == 0 ? form.timeList[0].startDate : '-' }}
                  {{ form.timeList[0].bookNumber > 0 && form.timeList[0].isNoBook == 0 && form.timeList[0].isOrder == 0 ? form.timeList[0].endDate : '-' }}
                </span>
                <samp v-else>请选择</samp>
                <el-button style="float: right;" type="primary" @click="chooseWell()">确定</el-button>
              </div>
            </div>
            <el-input slot="reference" v-model="chooseVal" style="width: 200px;margin-left: 20px;" placeholder="请选择预约时间" :readonly="true" suffix-icon="el-icon-arrow-down"></el-input>
          </el-popover>
        </el-form-item>
        <el-form-item label="选择员工：" prop="technician">
          <el-select v-model="form.technicianName" :disabled="!form.timeStart" :placeholder="'请选择'+Lib.collectively()">
            <el-option v-for="item in form.technicianList" :key="item.id"
                       :label="item.name"
                       :value="item.id" :disabled="(item.isLeave == 1 || item.isBooked == 1 || item.isNoBook == 1||item.isClass==0) ? true : false"
                       @click.native="(item.isLeave == 1 || item.isBooked == 1 || item.isNoBook == 1||item.isClass==0) ? '' : hancleClick(item)"
            >
              <span style="float: left">{{ item.name }}</span>
              <span v-show="item.isLeave==1||item.isClass==0" style="float: right; color: #ff5046;">(休息中)</span>
              <span v-show="!item.isLeave && item.isBooked == 1" style="float: right; color: #ff5046;">(已被预约)</span>
              <span v-show="!item.isLeave && !item.isBooked && item.isNoBook == 1" style="float: right; color: #ff5046;">(不可预约)</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="预约备注：" prop="remark">
          <el-input v-model="form.remark" style="width: 430px;" :maxlength="50" show-word-limit type="textarea" :rows="3" placeholder="请输入预约备注">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" :disabled="form.name && form.phone && form.comfirmRadio && form.date && form.chooseTimeIndex !== '' ? false : true" @click="submitStatus == false ? onSubmit() : ''">确定</el-button>
        </el-form-item>
      </el-form>

      <el-dialog class="merchandiserDialog chooseServiceCss" width="800px" title="选择项目" :visible.sync="form.serviceDialog" :append-to-body="true">
        <div class="el-message-box__content" style="padding: 0;">
          <span>项目分类：</span>
          <el-select v-model="form.chooseServiceTypeId" class="mr_20" placeholder="请选择项目分类" @change="changeServiceType">
            <el-option key="" label="全部" value=""></el-option>
            <el-option v-for="item in form.serviceTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-input v-model="form.searchServiceVal" class="width_200" placeholder="请输入项目名称" @keyup.enter.native="searchService">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="searchService"></i>
          </el-input>
          <div class="tablePointer" style="height: 528px;border: 1px solid #eee;margin-top: 15px;">
            <el-table tooltip-effect="light" :data="form.searchServiceList" class="newSelect" @row-click="choosePMEvent">
              <el-table-column type="selection" width="40">
                <template slot-scope="scope">
                  <el-radio v-model="form.choosePMRadio" :label="scope.row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="typeName" label="项目分类" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="name" label="项目名称" :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="price" label="价格（元）"></el-table-column>
              <el-table-column prop="serviceTime" label="服务时长（分钟）"></el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-pagination background style="float: left;padding: 7px 0;" :current-page.sync="form.pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="form.rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
          <el-button type="primary" @click="comfirmAddService">确 定</el-button>
          <el-button @click="cancelAddService">取 消</el-button>
        </span>
      </el-dialog>

      <book :show.sync="bookVisible"></book>

      <!-- 自定义服务时长 -->
      <el-dialog class="serviceTimeDialog" title="自定义服务时长" :visible.sync="serviceTimeDialog" width="400px" :append-to-body="true">
        <div class="dialog_header">
          <el-input-number v-model="duration" :min="15" :max="240"></el-input-number>
        </div>
        <div class="newFootCss">
          <div class="newFootBtn">
            <el-button @click="cancelSetTime()">取 消</el-button>
            <el-button type="primary" @click="comfirmSetTime">确 定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
  <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
</template>

<script>
import {
  getMemberCardMsg, postSaveBookOrder, getItemLIst, getItemTypeLIst, getProjectTimeList, getFansTechnicianList, getBilling4Book, getLongBook
} from '../api';
import book from '../../beautyCard/template/book';

let newSetTime;
export default {
  components: {
    book
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      clearTimeout(newSetTime);
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (this.Lib.CheckPhone(value) == false) {
        if (value.length == 11) {
          callback(new Error('请输入正确的手机号码!'));
        } else {
          newSetTime = setTimeout(() => {
            callback(new Error('请输入正确的手机号码!'));
          }, 1000);
        }
      } else {
        this.memberSearch();
        callback();
      }
    };
    const checkName = (rule, value, callback) => {
      if (!value && this.nameStatus) {
        callback(new Error('请输入顾客姓名'));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {}, // 新增预约选择时间限制--不能选择今天之前的日期
      form: { // 提交表单数据
        phone: '', // 顾客电话
        name: '', // 顾客名称
        technician: '', // 统称
        technicianName: '',
        date: '', // 日期
        service: '', // 服务项目
        remark: '',
        timeList: [],
        chooseTimeIndex: '',
        timeStart: '',
        timeEnd: '',
        bespeakId: '',
        serviceDialog: false,
        chooseServiceTypeId: '',
        serviceTypeList: [],
        searchServiceVal: '',
        searchServiceList: [],
        choosePMRadio: '',
        choosePMRadioName: '',
        comfirmRadio: '',
        comfirmRadioName: '',
        pageNum: 1,
        rowCount: 1,
        bookAmount: 0,
        deductType: 0,
        serviceTime: '',
        technicianList: [], // 可预约统称列表
      },
      rules: {
        phone: [
          { required: true, validator: checkPhone, trigger: 'change' },
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        name: [
          { required: true, validator: checkName, trigger: 'change' },
          { required: true, validator: checkName, trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择预约日期', trigger: 'change' },
          { required: true, message: '请选择预约日期', trigger: 'blur' }
        ],
      },
      nameStatus: true,
      submitStatus: false, // 提交状态
      nameInput: 1,

      starPhoneVal: '',
      starStatus: 1,

      // 6.0
      timeVal: '15分钟',
      chooseVal: '',

      // 6.2
      bookVisible: false,

      // 6.8
      serviceTimeDialog: false,
      duration: 15,
      oldTimeVal: 15,
    };
  },
  watch: {
    'form.phone': function (val) {
      this.phoneChange(val);
    }
  },
  activated() {
    this.getBespeakTime();
    this.form.bespeakId = window.sessionStorage.bespeakId;
    if (this.form.bespeakId) {
      this.starStatus = 2;
      this.nameInput = 2;
      this.getEditBespeakInfo(this.form.bespeakId);
    } else {
      this.nameInput = 1;
      this.$refs.ruleForm.resetFields();
      Object.assign(this.$data.form, this.$options.data().form);
      const date = new Date();
      this.form.date = this.Lib.D(date.getTime(), 'yyyy-MM-dd');
    }
    this.timeVal = '15分钟';
    this.durationTime();
  },
  deactivated() {
    this.form.phone = '';
    this.form.bookAmount = 0;
    this.form.deductType = 0;
  },
  methods: {
    // 查询顾客列表
    onCheckPhoneBook() {
      this.bookVisible = true;
    },
    checkMember(phone, name) {
      this.form.phone = phone;
      this.form.name = name;
    },
    // 搜索获取会员信息
    memberSearch() {
      this.nameStatus = false;
      const data = {
        keyWord: this.form.phone
      };
      getMemberCardMsg(data).then((res) => {
        if (res.data) {
          this.form.name = res.data.nickName;
          this.nameInput = res.data.nickName ? 2 : 1;
          setTimeout(() => {
            this.nameStatus = true;
          }, 100);
        }
      });
    },
    changeServiceType() {
      this.form.pageNum = 1;
      this.chooseService();
    },
    searchService() {
      this.Lib.keyboardBlur();
      this.form.pageNum = 1;
      this.chooseService();
    },
    choosePMEvent(row) {
      this.form.choosePMRadio = row.id;
      this.form.choosePMRadioName = row.name;
      this.form.serviceTime = row.serviceTime;
    },
    handleSizeChange(val) {
      this.form.pageNum = val;
      this.chooseService();
    },
    handleCurrentChange(val) {
      this.form.pageNum = val;
      this.chooseService();
    },
    comfirmAddService() {
      this.form.serviceDialog = false;
      const radio = this.form.choosePMRadio;
      const name = this.form.choosePMRadioName;
      this.form.comfirmRadio = radio;
      this.form.comfirmRadioName = name;
      this.timeVal = `${this.form.serviceTime}分钟`;
      this.oldTimeVal = this.form.serviceTime;
      this.form.technician = '';
      this.form.timeStart = '';
      this.form.timeEnd = '';
      this.form.technicianName = '';
      this.chooseVal = '';
      this.form.chooseTimeIndex = '';
      this.chooseDate();
    },
    cancelAddService() {
      this.form.serviceDialog = false;
      const radio = this.form.comfirmRadio;
      const name = this.form.comfirmRadioName;
      this.form.choosePMRadio = radio;
      this.form.choosePMRadioName = name;
    },
    // 清空预约时间数据~
    durationTime(val) {
      if (val === '自定义') {
        this.serviceTimeDialog = true;
        return;
      }
      if (String(this.timeVal).charAt(this.timeVal.length - 1) != '钟') {
        this.form.serviceTime = this.timeVal;
      }
      this.oldTimeVal = val;
      this.form.timeStart = '';
      this.form.timeEnd = '';
      this.chooseVal = '';
      this.form.chooseTimeIndex = '';
      this.form.technicianName = '';
      this.chooseDate();
    },
    cancelSetTime() {
      this.serviceTimeDialog = false;
      this.timeVal = `${JSON.parse(JSON.stringify(this.oldTimeVal))}分钟`;
    },
    // 确认设置服务时长
    comfirmSetTime() {
      this.form.serviceTime = JSON.parse(JSON.stringify(this.duration));
      this.timeVal = `${JSON.parse(JSON.stringify(this.duration))}分钟`;
      this.oldTimeVal = `${JSON.parse(JSON.stringify(this.duration))}分钟`;
      this.durationTime(this.form.serviceTime);
      this.serviceTimeDialog = false;
    },
    // 得到改变日期
    getDate() {
      this.chooseDate();
      this.durationTime();
    },
    // 改变选择日期
    chooseDate() {
      if (this.form.serviceTime == '0小时15分钟') {
        this.form.serviceTime = 15;
      }
      const data = {
        mainId: window.sessionStorage.mainId,
        itemId: this.form.comfirmRadio,
        id: this.form.bespeakId,
        date: this.form.date,
        serviceTime: this.form.serviceTime
      };
      getProjectTimeList(data).then((res) => {
        if (res.code == 0) {
          this.form.timeList = res.data ? res.data : [];
          for (let i = 0; i < this.form.timeList.length; i++) {
            if (this.form.timeStart == this.form.timeList[i].startDate && this.form.timeEnd == this.form.timeList[i].endDate) {
              this.form.chooseTimeIndex = i;
              this.form.timeList[i].isOrder = 0;
            }
          }
        }
      });
    },
    // 选择预约时间
    chooseTime(index, item) {
      if (item.isNoBook == 1) {
        this.$message('该时间段已设置不可约，请选择其他时间段');
      } else if (item.isOrder == 0) {
        this.form.chooseTimeIndex = index;
        this.form.timeStart = item.startDate;
        this.form.timeEnd = item.endDate;
        this.chooseVal = `${this.form.timeStart}-${this.form.timeEnd}`;
        this.getTechnicianListData();
      } else {
        this.$message('该时间段预约已满，请选择其他时间段');
      }
    },
    // 确定选好项目时间
    chooseWell() {
      document.getElementById('app').click();
    },
    // 选择项目
    chooseService() {
      const vm = this;
      if (vm.form.bookAmount > 0 || vm.form.deductType == 1) {
        this.$message(`预约订单中已${vm.form.bookAmount > 0 ? '支付定金' : '使用划扣次数'}，不可更改预约项目`);
        return;
      }
      vm.form.serviceDialog = true;
      getItemTypeLIst().then((res) => {
        if (res.code == 0) {
          vm.form.serviceTypeList = res.data;
          const data = {
            mainId: window.sessionStorage.mainId,
            typeId: vm.form.chooseServiceTypeId ? vm.form.chooseServiceTypeId : '',
            keyWord: vm.form.searchServiceVal,
            pageNum: vm.form.pageNum
          };
          getItemLIst(data).then((resTwo) => {
            if (resTwo.code == 0) {
              vm.form.searchServiceList = resTwo.data.records;
              vm.form.rowCount = resTwo.data.total;
            }
          });
        }
      });
    },
    // 获取统称列表数据
    getTechnicianListData() {
      const data = {
        mainId: window.sessionStorage.mainId,
        pageNum: 1,
        itemId: this.form.comfirmRadio,
        startDate: this.form.timeStart,
        endDate: this.form.timeEnd,
        bookDate: this.form.date,
        isFilter: 1, // 是否排班筛选(0否  1是)

      };
      getFansTechnicianList(data).then((res) => {
        this.form.technicianList = res.data.records;
      });
    },
    // 选择员工
    hancleClick(item) {
      console.log(123);
      this.form.technician = item.id;
      this.form.technicianName = item.name;
    },
    // 提交数据
    onSubmit() {
      const vm = this;
      if (vm.Lib.CheckPhone(vm.form.phone) == false) {
        vm.$message('请输入正确的手机号码');
        return;
      }
      vm.submitStatus = true;
      this.nameStatus = true;
      const data = {
        id: vm.form.bespeakId,
        itemId: vm.form.comfirmRadio,
        memberName: vm.form.name,
        phone: vm.form.phone,
        remark: vm.form.remark,
        technicianId: vm.form.technician || null,
        orderSource: 0,
        serviceTime: vm.form.serviceTime,
        timeEnd: `${vm.form.date} ${vm.form.timeEnd}`,
        timeStart: `${vm.form.date} ${vm.form.timeStart}`
      };
      postSaveBookOrder(data).then((res) => {
        if (res.code == 0) {
          vm.$message({
            message: res.msg,
            type: 'success'
          });
          vm.submitStatus = false;
          vm.$router.push({
            name: 'stage-allDay'
          });
        } else {
          vm.submitStatus = false;
        }
      });
    },
    // 获取修改信息
    getEditBespeakInfo(id) {
      const data = { orderId: id };
      getBilling4Book(data).then((res) => {
        if (res.code == 0) {
          this.phoneChange(res.data.phone);
          this.form.bookAmount = res.data.bookAmount * 1;
          this.form.deductType = res.data.deductType;
          this.form.name = res.data.memberName;
          this.form.phone = res.data.phone;
          this.form.choosePMRadio = res.data.itemId;
          this.form.chooseServiceTypeId = res.data.itemTypeId;
          this.form.technician = res.data.technicianId;
          this.form.technicianName = res.data.technicianName;
          this.form.comfirmRadioName = res.data.itemName;
          this.form.serviceTime = res.data.serviceTime;
          this.form.comfirmRadio = res.data.itemId;
          this.form.date = res.data.date;
          this.form.timeStart = res.data.timeStart;
          this.form.timeEnd = res.data.timeEnd;
          this.timeVal = `${this.form.serviceTime}分钟`;
          this.oldTimeVal = this.form.serviceTime;
          this.chooseVal = `${this.form.timeStart}-${this.form.timeEnd}`;
          this.chooseDate(res.data.technicianId, res.data.timeStart);
          this.getTechnicianListData();
        }
      });
    },
    // 获取预约最长时间
    getBespeakTime() {
      const data = { mainId: window.sessionStorage.mainId };
      getLongBook(data).then((res) => {
        const days = this.Lib.totalDays(res.data.longBookTime ? res.data.longBookTime : 1);
        this.pickerOptions = {
          disabledDate(time) {
            return Date.now() > (time.getTime() + 3600 * 1000 * 24) || Date.now() < (time.getTime() - 3600 * 1000 * 24 * days);
          }
        };
      });
    },
    // 监听手机号事件
    phoneChange(val) {
      if (this.starStatus == 2 && window.sessionStorage.isHidePhone == 1) {
        this.starPhoneVal = val.length == 4 ? '*' : val.length == 5 ? '**' : val.length == 6 ? '***' : val.length > 6 ? '****' : '';
      } else {
        this.starPhoneVal = '';
      }
      if (val.length < 4) {
        this.starStatus = 1;
      }
    }
  }
};
</script>

<style>
.timeList_T {
  background-color: #d8dce5 !important;
  color: #fff !important;
}
.timeList .li {
  width: 218px;
  height: 40px;
  line-height: 40px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #d8dce5;
  color: #5a5e66;
  font-size: 14px;
  text-align: center;
  margin: 0 20px 20px 0;
  float: left;
  cursor: pointer;
}
.infoTitle {
  color: #2d2f33;
  font-size: 14px;
}
.merchandiserDialog
  .el-table__header-wrapper
  .el-table__header
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner {
  display: none !important;
}
</style>

<style lang="less" scoped>
.bespeakServiceChoose {
  float: left;
  padding: 0 15px;
  border-radius: 4px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  text-align: center;
  margin: 4px 0 4px 10px;
}
.chooseTimeCss {
  float: left;
  padding: 0 15px;
  border-radius: 4px;
  height: 34px;
  line-height: 34px;
  font-size: 14px;
  text-align: center;
  border: 1px solid #d8dce5;
  color: #666;
  margin: 10px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 148px;
}
.comfirmChooseTime {
  color: #fff;
}
.starPhoneClass {
  position: absolute;
  font-size: 18px;
  margin-top: -53px;
  margin-left: 141px;
  background-color: #fff;
  width: 33px;
  user-select: none;
}
// 6.0
.chooseContent {
  display: block;
  padding: 20px;
  ul {
    display: inline-block;
    list-style-type: none;
    border-bottom: 2px solid #EBEEF5;
    padding-bottom: 16px;
    width: 100%;
    .choose {
      width: 70px;
      height: 32px;
      line-height: 32px;
      margin-bottom: 4px;
      background: #FC5B8B;
      border-radius: 4px;
      font-size: 14px;
      span {
        display: block;
        width: 70px;
        font-size: 14px;
        color: #fff;
        margin-top: 8px;
        height: 19px;
        line-height: 19px;
      }
    }
    li {
      text-align: center;
      width: 70px;
      height: 45px;
      margin-bottom: 12px;
      display: inline-block;
      vertical-align: text-top;
      span {
        display: block;
        width: 70px;
        font-size: 14px;
        color: #333;
        margin-top: 8px;
        height: 19px;
        line-height: 19px;
      }
      samp {
        display: block;
        width: 70px;
        font-size: 12px;
        color: #333;
        margin-top: 7px;
        height: 16px;
        line-height: 16px;
      }
      label {
        display: block;
        width: 70px;
        font-size: 12px;
        color: #F56C6C;
        margin-top: 7px;
        height: 16px;
        line-height: 16px;
      }
    }
  }
  .ctFoot {
    height: 40px;
    line-height: 40px;
    padding: 30px 0 10px 0;
    span {
      font-size: 14px;
      color: #333;
      float: left;
    }
    samp {
      font-size: 14px;
      color: #C0C4CC;
      float: left;
    }
  }
}
.newFootCss {
  padding: 15px 0 20px 0;
  .newFootBtn {
    float: right;
    display: block;
    width: 100%;
    text-align: right;
    padding-top: 7px;
  }
}
</style>
